import { Box, IconButton, Paper, Typography } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import { RelatedProductCandidate } from '../../../../interfaces/RelatedProduct/RelatedProductCandidate';
import { sharedColors, sharedStyles } from '../../../../utils/Style';

type RelatedProductChipProps = {
  entry: RelatedProductCandidate;
  onDelete: () => void;
};

export const RelatedProductChip = (props: RelatedProductChipProps) => {
  return (
    <Paper sx={{ backgroundColor: sharedColors.primary, p: 1.25 }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <IconButton
          size='small'
          onClick={props.onDelete}
          sx={{
            color: sharedColors.white,
            p: 0,
            minHeight: 0,
            minWidth: 0,
          }}
        >
          <CancelIcon />
        </IconButton>
        <Typography sx={{ ...sharedStyles.body1, color: sharedColors.white }}>
          {props.entry.name}
        </Typography>
      </Box>
    </Paper>
  );
};
